module.exports = __webpack_public_path__ + "img/logo.943a435e.png";